import { PayloadAction, WithSlice, createSlice } from "@reduxjs/toolkit";
import { rootReducer } from "Store/rootReducer";

type DialogsState = {
  moveToProjectsDialog: {
    isOpen: boolean;
  };
  shareReportDialog: {
    isOpen: boolean;
    contactSupport: boolean;
  };
};

const initialState: DialogsState = {
  moveToProjectsDialog: {
    isOpen: false,
  },
  shareReportDialog: {
    isOpen: false,
    contactSupport: false,
  },
};

const dialogsSlice = createSlice({
  name: "shareableReports",
  initialState: initialState,
  reducers: {
    openMoveToProject: (state) => {
      state.moveToProjectsDialog = {
        isOpen: true,
      };
    },
    closeMoveToProject: (state) => {
      state.moveToProjectsDialog = {
        isOpen: false,
      };
    },
    openShareReport: (
      state,
      action: PayloadAction<{
        contactSupport: boolean;
      }>,
    ) => {
      state.shareReportDialog = {
        isOpen: true,
        contactSupport: action.payload.contactSupport,
      };
    },
    closeShareReport: (state) => {
      state.shareReportDialog = {
        isOpen: false,
        contactSupport: false,
      };
    },
  },
  selectors: {
    selectMoveToProjectDialog: (state) => state.moveToProjectsDialog,
    selectShareReportDialog: (state) => state.shareReportDialog,
  },
});

const injectedSlice = dialogsSlice.injectInto(rootReducer);

export const {
  closeMoveToProject,
  closeShareReport,
  openMoveToProject,
  openShareReport,
} = dialogsSlice.actions;

export const { selectMoveToProjectDialog, selectShareReportDialog } =
  injectedSlice.selectors;

declare module "Store/rootReducer" {
  export interface LazyLoadedSlices extends WithSlice<typeof dialogsSlice> {}
}
